<div class="container-content" fxLayout="column">

  <h1 class="fs-2 fw-bold">
    {{ 'mbr.registration-data-retrieval.title' | translate }}
  </h1>

  <div class="accordion" id="mbrRetrieveNamesAccordion">
    <!-- Install the app -->
    <div class="accordion-item">
      <h2 class="accordion-header" id="installAblageAppHeading">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#installAblageAppCollapse"
          aria-expanded="false"
          aria-controls="installAblageAppCollapse"
        >
          {{ 'mbr.registration-data-retrieval.install-ablage-app.title' | translate }}
        </button>
      </h2>
      <div
        id="installAblageAppCollapse"
        class="accordion-collapse collapse"
        aria-labelledby="installAblageAppHeading"
      >
        <div class="accordion-body">
      {{ 'mbr.registration-data-retrieval.install-ablage-app.text.part-1' | translate }}

      <div class="row g-3">
        <div class="col-md-6">
          <div class="grid-tile d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div class="grid-tile-header">
              {{ 'mbr.registration-data-retrieval.install-ablage-app.text.apple-app-store.text' | translate }}
            </div>
            <img
              class="qr-code"
              src="/assets/img/mbr/Ablage_App-Apple_App_Store.png"
              [alt]="'mbr.registration-data-retrieval.install-ablage-app.text.apple-app-store.qr-code-alt' | translate"
            >
            <div class="grid-tile-footer">
              <a [href]="'mbr.registration-data-retrieval.install-ablage-app.text.apple-app-store.link' | translate">
                {{ 'mbr.registration-data-retrieval.install-ablage-app.text.apple-app-store.link' | translate }}
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="grid-tile d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div class="grid-tile-header">
              {{ 'mbr.registration-data-retrieval.install-ablage-app.text.google-play-store.text' | translate }}
            </div>
            <img
              class="qr-code"
              src="/assets/img/mbr/Ablage_App-Google_Play_Store.png"
              [alt]="'mbr.registration-data-retrieval.install-ablage-app.text.google-play-store.qr-code-alt' | translate"
            >
            <div class="grid-tile-footer">
              <a [href]="'mbr.registration-data-retrieval.install-ablage-app.text.google-play-store.link' | translate">
                {{ 'mbr.registration-data-retrieval.install-ablage-app.text.google-play-store.link' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>

    <!-- Request data fields -->
    <div class="accordion-item">
      <h2 class="accordion-header" id="retrieveDataHeading">
        <span class="accordion-button" aria-disabled="true">
          {{ 'mbr.registration-data-retrieval.retrieve-data.title' | translate }}
        </span>
      </h2>
      <div
        id="retrieveDataCollapse"
        class="accordion-collapse collapse show"
        aria-labelledby="retrieveDataHeading"
      >
        <div class="accordion-body">
      <p>
        {{ 'mbr.registration-data-retrieval.retrieve-data.text.description' | translate }}
      </p>
      <div class="data-qr-code">
        <div class="row">
          <div class="col-12">
            <div class="grid-tile d-flex align-items-center justify-content-center">
              <img
                class="qr-code"
                [src]="qrCodeSrc"
                [alt]="'mbr.registration-data-retrieval.retrieve-data.text.qr-code-alt' | translate"
              >
            </div>
          </div>
        </div>
      </div>
      <p>
        {{ 'mbr.registration-data-retrieval.retrieve-data.text.link' | translate }}
        <a [href]="enmeshedAppLink">{{ enmeshedAppLink }}</a>
        <button class="btn btn-primary" type="button" (click)="copyLinkToClipboard()">
          <i class="bi bi-copy"></i>
        </button>
      </p>

      <ng-container *ngIf="!completed; else confirmationText">
        {{ 'mbr.registration-data-retrieval.retrieve-data.text.waiting-text.part-1' | translate }}
        <time [dateTime]="remainingTime?.toString()">{{ timeInMinutesAndSeconds(remainingTime) }}</time>
        {{ 'mbr.registration-data-retrieval.retrieve-data.text.waiting-text.part-2' | translate }}
      </ng-container>

      <ng-template #confirmationText>
        {{ 'mbr.registration-data-retrieval.retrieve-data.text.confirmation-text' | translate }}
      </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end me-3">
    <button
      *ngIf="!completed"
      type="button"
      class="btn btn-warning"
      (click)="logoutAndDeleteUser()"
    >
      {{ 'button.logout-and-delete-account' | translate }}
    </button>
    <button
      *ngIf="completed"
      type="button"
      class="btn btn-primary"
      (click)="continueToDashboard()"
    >
      {{ 'button.next' | translate }}
    </button>
  </div>
</div>
